import { useWallet } from "@/hooks/useWallet";
import { DashboardView } from "@/components/dashboard/DashboardView";

export default function SpotPerformance() {
  const { address } = useWallet();

  if (!address) return null;

  return <DashboardView address={address} marketType="spot" />;
}
